/* MY RARE AURA — SAFE PREMIUM MOTION SYSTEM */

(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready() {
    document.documentElement.classList.add('aurelle-page-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  function cleanupDrawerOverlay() {
    const drawer = document.querySelector('cart-drawer');

    if (drawer && !drawer.classList.contains('active')) {
      document.body.classList.remove('overflow-hidden', 'drawer-open', 'cart-open');
      document.documentElement.classList.remove('overflow-hidden', 'drawer-open', 'cart-open');

      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      document.querySelectorAll('.drawer__overlay, .aurelle-cart-overlay').forEach(function (overlay) {
        overlay.style.opacity = '';
        overlay.style.visibility = '';
        overlay.style.pointerEvents = '';
      });
    }
  }

  function initDrawerCleanup() {
    document.addEventListener('click', function (event) {
      if (
        event.target.closest('.drawer__close') ||
        event.target.closest('.aurelle-cart-close') ||
        event.target.closest('.drawer__overlay') ||
        event.target.closest('.aurelle-cart-overlay')
      ) {
        setTimeout(cleanupDrawerOverlay, 450);
      }
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') {
        setTimeout(cleanupDrawerOverlay, 450);
      }
    });
  }

  function initReveal() {
    const revealSelectors = [
      '.aurelle-benefits-row',
      '.aurelle-accordions',
      '.aurelle-editorial-wide',
      '.aurelle-complete-look',
      '.aurelle-recently-viewed',
      '.aurelle-reveal'
    ];

    const elements = Array.from(document.querySelectorAll(revealSelectors.join(',')));

    if (!elements.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach(el => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });

    elements.forEach(el => observer.observe(el));
  }

  function initStagger() {
    const grids = document.querySelectorAll(
      '.aurelle-complete-products-grid, .aurelle-recent-grid, .aurelle-benefits-row'
    );

    grids.forEach(grid => grid.classList.add('aurelle-stagger'));
  }

  function initLensTracking() {
    const buttons = document.querySelectorAll('.aurelle-main-image-button');

    buttons.forEach(button => {
      button.addEventListener('mousemove', function (event) {
        const rect = button.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;

        button.style.setProperty('--aurelle-lens-x', x + '%');
        button.style.setProperty('--aurelle-lens-y', y + '%');
      });
    });
  }

  function initLoadingButtons() {
    document.addEventListener('click', function (event) {
      const button = event.target.closest(
        '.aurelle-add, .aurelle-quickview-add, .aurelle-sticky-atc button'
      );

      if (!button || button.disabled) return;
      if (button.closest('cart-drawer')) return;

      button.classList.add('aurelle-is-loading');

      window.setTimeout(() => {
        button.classList.remove('aurelle-is-loading');
      }, 1200);
    });
  }

  function initSmoothAnchors() {
    document.addEventListener('click', function (event) {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;

      const id = link.getAttribute('href');
      if (!id || id === '#') return;

      const target = document.querySelector(id);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  }

  function initHoverIntent() {
    document.addEventListener('pointerenter', function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      const card = event.target.closest(
        '.aurelle-complete-product-card, .aurelle-recent-card'
      );

      if (card) card.classList.add('is-hovered');
    }, true);

    document.addEventListener('pointerleave', function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      const card = event.target.closest(
        '.aurelle-complete-product-card, .aurelle-recent-card'
      );

      if (card) card.classList.remove('is-hovered');
    }, true);
  }

  function init() {
    initDrawerCleanup();
    initStagger();
    initReveal();
    initLensTracking();
    initLoadingButtons();
    initSmoothAnchors();
    initHoverIntent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();